import React, { useCallback } from "react";
import { Patient } from "@shared/models";
import { NameOfChildRoutes, NamesOfParentRoutes } from "@shared/constants";
import { PATIENT_TYPE } from "@shared/interfaces";
import { useHorizontalScroll } from "@shared/hooks";
import { useNavigate } from "react-router";

import { ReactComponent as ArrowIcon } from "../../../../../assets/images/icons/general/arrow-right-black.svg";
import { NewPatientCard } from "./components";

import "./index.scss";

const MAX_PATIENTS = 4;

interface NewPatientCardsProps {
  patients: Patient[];
  patientsTotal: number;
}

const NewPatientCards = (props: NewPatientCardsProps) => {
  const { patients, patientsTotal } = props;
  const scrollRef = useHorizontalScroll();
  const navigate = useNavigate();

  const handleViewAllPatients = useCallback(() => {
    navigate(`${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.PATIENTS.ROOT}?type=${PATIENT_TYPE.NEW}`);
  }, [navigate]);

  return (
    <div className="new-patients-cards">
      <div className="new-patients-cards-header">
        <div className="show-count-patients">New Patients ({patientsTotal})</div>
        {patientsTotal > MAX_PATIENTS ? (
          <div className="show-all-patients" onClick={handleViewAllPatients}>
            View All <ArrowIcon />
          </div>
        ) : null}
      </div>
      {patients.length ? (
        <div className="new-patients-cards-list" ref={scrollRef as any}>
          {patients.map((p) => (
            <NewPatientCard patient={p} key={p.id} />
          ))}
        </div>
      ) : (
        <div className="panel no-patients-block">No Patients to display</div>
      )}
    </div>
  );
};

export default NewPatientCards;
